import React from "react";

// Helper to underline and bold only the <u>...</u> part in the question string
function renderQuestionWithUnderline(question) {
    if (typeof question !== 'string') {
        return { __html: '' };
    }
    return {
        __html: question
            // Bold _★_
            .replace(/_★_/g, '<span style="font-weight:bold;">_★_</span>')
            // Underline and bold patterns
            .replace(/<b><u>(.*?)<\/u><\/b>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
            .replace(/<b><u>(.*?)<\/b><\/u>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
            .replace(/<u>(.*?)<\/u>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
    };
}

const N5BunpooQ2 = ({
    questions,
    selectedAnswers,
    showResult,
    handleAnswerChange,
}) => {
    if (!questions) return null;

    return (
        <div>
            <div style={{ fontSize: "1.2rem", marginBottom: "0.5rem", fontWeight: 'bold' }}>
                もんだい2 _★_に入るものは　どれですか。 1・2・3・4から いちばん　いい ものを　1 つえらんで ください。
            </div>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                {questions.map((item, idx) => (
                    <li
                        key={item.id}
                        style={{
                            marginBottom: '2.5rem',
                            width: '100%',
                            background: '#f8faff',
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
                            padding: '1.2rem'
                        }}
                    >
                        <div style={{ marginBottom: '1rem', fontSize: '1.2rem', fontWeight: 500 }}>
                            <span
                                style={{
                                    marginRight: 12,
                                    color: idx === 0 ? 'bold' : 'inherit',
                                    fontWeight: idx === 0 ? 'bold' : 'normal'
                                }}
                            >
                                {idx === 0 ? '(もんだいれい)' : idx + 9}.
                            </span>
                            <span dangerouslySetInnerHTML={renderQuestionWithUnderline(item.question)} />
                        </div>

                        {item.answers && item.answers.length === 4 && (
                            <div style={{ display: 'block', width: '100%' }}>
                                {item.answers.map((ans, ansIdx) => {
                                    const isSelected = selectedAnswers[item.id] === ansIdx;
                                    let color = undefined;
                                    if (showResult) {
                                        if (ansIdx === item.correct) {
                                            color = 'green';
                                        } else if (isSelected) {
                                            color = 'red';
                                        }
                                    }

                                    return (
                                        <label
                                            key={ansIdx}
                                            style={{
                                                display: 'block',
                                                alignItems: 'center',
                                                width: '100%',
                                                padding: '0.8rem 1rem',
                                                marginBottom: '0.7rem',
                                                borderRadius: '6px',
                                                border: '1px solid #e0e0e0',
                                                background: '#fff',
                                                cursor: showResult ? 'default' : 'pointer',
                                                fontSize: '1.2rem',
                                                fontWeight: isSelected ? 700 : 500,
                                                textDecoration: isSelected ? 'underline' : 'none',
                                                color: color,
                                                transition: 'all 0.2s',
                                                wordBreak: 'break-word',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                name={`question-${item.id}`}
                                                value={ansIdx}
                                                checked={isSelected}
                                                onChange={() => handleAnswerChange(item.id, ansIdx)}
                                                disabled={showResult}
                                                style={{
                                                    marginRight: 14,
                                                    accentColor: "#1976d2",
                                                    width: 22,
                                                    height: 22
                                                }}
                                            />
                                            <span dangerouslySetInnerHTML={renderQuestionWithUnderline(ans)} />
                                            {showResult && ansIdx === item.correct && (
                                                <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'green' }}>✓</span>
                                            )}
                                            {showResult && isSelected && ansIdx !== item.correct && (
                                                <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'red' }}>✗</span>
                                            )}
                                        </label>
                                    );
                                })}
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default N5BunpooQ2;
